<template>
  <div class="propertyTemplate">
<!--    <el-card>-->
<!--      <el-page-header @back="goBack" content="属性"></el-page-header>-->
<!--    </el-card>-->
    <main class="content">
      <el-card>
        <el-table stripe  :data="tableData" v-loading="loading" style="width: 100%">
          <el-table-column prop="name" label="名称" width="300"></el-table-column>
          <el-table-column prop="unit" label="单位"></el-table-column>
          <el-table-column prop="description" label="描述"></el-table-column>
          <el-table-column label="操作" width="350" align="right">
            <template slot="header">
              <el-button type="primary" size="mini" @click="handleCreate" v-if="edit">添加</el-button>
            </template>
            <template slot-scope="scope">
              <el-button size="mini" :disabled="!edit || !scope.row.canEdit" @click="handleEdit(scope.$index, scope.row)">编辑信息</el-button>
              <el-button size="mini" :disabled="!edit || !scope.row.canEdit" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center;padding-top: 20px">
          <el-pagination
            background
            layout="sizes,prev, pager, next"
            :page-sizes="[10, 20, 50, 100]"
            v-if="total>0"
            :total="total"
            :page-size="pageSize"
            @size-change="handleSizeChange"
            @current-change="onPageChange"
            @prev-click="onPageChange"
            @next-click="onPageChange"
          ></el-pagination>
        </div>
      </el-card>
    </main>
    <el-dialog title="属性模板" :visible.sync="editDialogVisible" width="700px" :close-on-click-modal="false">
      <el-form ref="editForm" :model="editForm" :rules="rules" label-width="80px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="editForm.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="单位">
          <el-input v-model="editForm.unit" clearable></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="editForm.description" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchForm: {
        name: "",
        status: ""
      },
      loading: false,
      fPropertyLoading: false,
      total: 0,
      pageSize: 10,
      currentPage: 1,
      tableData: [],
      editDialogVisible: false,
      editForm: {
        id: "",
        name: "",
        unit: "",
        description: "",
      },
      property: [],
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
      },
    };
  },
  props: ["templateId", "edit"],
  methods: {
    onSearch() {
      this.loading = true;
      let _this = this;
      this.$axios
        .get("/admin/property/template/listProperty/" + this.templateId)
        .then(function(response) {
          let resp = response.data;
          if (resp.header.status == 0) {
            _this.loading = false;
            _this.tableData = resp.data;
            // _this.total = resp.data.totalElements;
          }
        })
        .catch(function() {});
    },
    handleCreate() {
      this.editForm.id = "";
      this.editForm.name = "";
      this.editForm.unit = "";
      this.editForm.description = "";
      this.editDialogVisible = true;
    },
    onSubmit() {
      let that = this;
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$axios
          .post("/admin/property/template/addProperty", {
            templateId: this.templateId,
            ... this.editForm
          })
          .then(function(response) {
            let resp = response.data;
            if (resp.header.status == 0) {
              that.$notify({
                title: "成功",
                message: "数据保存成功",
                type: "success"
              });
              that.editDialogVisible = false;
              that.onSearch();
            } else {
              that.$notify.error({
                title: "错误",
                message: resp.header.msg
              });
            }
          });
        }
      });
    },
    handleSizeChange(pageSize){
      this.pageSize = pageSize;
      this.onSearch();
    },
    onPageChange(currentPage) {
      this.currentPage = currentPage;
      this.onSearch();
    },
    handleEdit(index, row) {
      this.editForm.id = row.id;
      this.editForm.name = row.name;
      this.editForm.unit = row.unit;
      this.editForm.description = row.description;
      this.editDialogVisible = true;
    },
    handleDelete(index, row) {
      let _this = this;
      this.$confirm("是否删除属性模板【" + row.name + "】？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消"
      }).then(() => {
        _this.$axios
          .post("/admin/property/template/delProperty", {
            id: row.id
          })
          .then(function(response) {
            let resp = response.data;
            if (resp.header.status === 0) {
              _this.$notify({
                title: "成功",
                message: "数据删除成功",
                type: "success"
              });
              _this.onSearch();
            } else {
              _this.$notify.error({
                title: "错误",
                message: resp.header.msg
              });
            }
          });
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    loadProperty(query) {
      if (query == "") return;
      this.fPropertyLoading = true;
      let _this = this;
      this.$axios
        .post("/admin/property/list", {
          name: query
        })
        .then(function(response) {
          let resp = response.data;
          if (resp.header.status == 0) {
            _this.fPropertyLoading = false;
            _this.property = resp.data;
          }
        })
        .catch(function() {});
    },
  },
  created() {
    let paramsStore;
    const params = sessionStorage.getItem("params");
    if(params) {
      paramsStore = JSON.parse(params);
    }
    const { templateId,edit } = JSON.stringify(this.$route.params)== "{}"?paramsStore:this.$route.params;
    this.edit = edit;
    this.templateId = templateId;
    this.onSearch();
  }
};
</script>
<style>
</style>